<template>
  <span
    class="announcement-remove"
    :title="'announcement-remove.lbl-remove' | globalize"
  >
    <a-popconfirm
      :title="'announcement-remove.icon-remove-quest' | globalize"
      :ok-text="'announcement-remove.icon-remove-answer-yes' | globalize"
      :cancel-text="'announcement-remove.icon-remove-answer-no' | globalize"
      @confirm="onClick"
    >
      <a-icon type="delete" />
    </a-popconfirm>
  </span>
</template>

<script>
import APopConfirm from 'ant-design-vue/lib/popconfirm'
import AIcon from 'ant-design-vue/lib/icon'
import 'ant-design-vue/lib/icon/style/index.css'
import 'ant-design-vue/lib/popover/style/index.css'
import 'ant-design-vue/lib/button/style/index.css'

export default {
  name: 'announcement-remove',
  components: {
    AIcon,
    'a-popconfirm': APopConfirm,
  },
  props: {
    onClick: {
      type: Function,
      default: () => {},
    },
  },
}

</script>

<style scoped>
  .announcement-remove {
    cursor: pointer;
    float: right;
    padding-left: 1em;
  }
</style>
